import React, { useState } from "react";
import { useSelector } from "react-redux";
import { backendUrl } from "../../constants";
import TimeFormat from "../../components/timeFormat/timeFormat";

const CampaignUpdates = ({
    campaign,
    remainingUpdates = 0,
    user,
    seeMore,
    setPreviewImages,
    setPreviewIndex,
    setPreviewVisible,
    campaignUpdateTotal,
    campaignUpdateList,
    isAdvisorUser
}) => {
    const [expanded, setExpanded] = useState({}); // track per item

    const CHAR_LIMIT = 600; // ✅ global standard

    const toggleReadMore = (index) => {
        setExpanded(prev => ({
            ...prev,
            [index]: !prev[index]
        }));
    };

    const numColumns = 4;
    const spacing = 12;
    const itemSize = 90; // adjust based on layout

    const imagePath = campaign?.company?.isDefault
        ? campaign?.creator?.profilePic?.filename
        : campaign?.company?.logo;

    const imageUrl = imagePath ? `${backendUrl}${imagePath}` : null;

    const placeholder = "/assets/img/Frame1.svg";
    return (
        <div className="campaign-update-wrapper">

            {/* Header */}
            <div className="campaign-update-header">
                <h3 className="campaign-update-title">Updates</h3>

                {remainingUpdates > 0 && (
                    <div className="campaign-update-badge">
                        {remainingUpdates}
                    </div>
                )}
            </div>
            {campaignUpdateList?.length > 0 ?
                <>
                    {/* List */}
                    {campaignUpdateList.map((item, index) => {
                        const isExpanded = expanded[index];
                        const text = item?.description || "";
                        const isLong = text.length > CHAR_LIMIT;
                        return (
                            <div key={index} className="campaign-update-item">

                                {/* Top Row */}
                                <div className="campaign-update-top">
                                    <img
                                        className="campaign-update-avatar"
                                        src={imageUrl || placeholder}
                                        alt="profile"
                                        onError={(e) => {
                                            e.currentTarget.onerror = null;
                                            e.currentTarget.src = placeholder;
                                        }}
                                    />

                                    <div>
                                        <div className="campaign-update-time">
                                            <TimeFormat time={item.createdAt} type={3} />
                                        </div>

                                        <div className="campaign-update-name">
                                            {campaign?.company?.isDefault
                                                ? `${user?.first_name} ${user?.last_name}`
                                                : campaign?.company?.companyName} {campaign?.company?.isDefault ? '(partner)' : ""}
                                        </div>
                                    </div>
                                </div>

                                {/* Description */}
                                <p className="campaign-update-desc">
                                    {isExpanded || !isLong
                                        ? text
                                        : text.slice(0, CHAR_LIMIT) + "..."}

                                    {isLong && (
                                        <span
                                            className="campaign-update-readmore"
                                            onClick={() => toggleReadMore(index)}
                                        >
                                            {isExpanded ? " Read less" : " Read more"}
                                        </span>
                                    )}
                                </p>
                                {/* Images */}
                                {item?.images?.length > 0 && (
                                    <div className="campaign-update-images">
                                        {item.images.slice(0, 3).map((img, i) => {
                                            const remaining = item.images.length - 3;

                                            return (
                                                <div
                                                    key={i}
                                                    className="campaign-update-img-box"
                                                    onClick={() => {
                                                        setPreviewImages(item.images);
                                                        setPreviewIndex(i);
                                                        setPreviewVisible(true);
                                                    }}
                                                    style={{
                                                        width: itemSize,
                                                        height: itemSize,
                                                        marginRight: (i + 1) % numColumns === 0 ? 0 : spacing,
                                                        marginBottom: spacing
                                                    }}
                                                >
                                                    <img
                                                        src={img?.filename ? backendUrl + img.filename : "/assets/img/peopleAi.png"}
                                                        alt=""
                                                        className="campaign-update-img"
                                                        onError={(e) => {
                                                            e.target.onerror = null; // prevents infinite loop
                                                            e.target.src = "/assets/img/peopleAi.png";
                                                        }}
                                                    />

                                                    {/* Overlay */}
                                                    {i === 2 && remaining > 0 && (
                                                        <div className="campaign-update-overlay">
                                                            +{remaining}
                                                        </div>
                                                    )}
                                                </div>
                                            );
                                        })}
                                    </div>
                                )}
                            </div>
                        )
                    })}

                    {/* See More */}
                    {campaignUpdateTotal > campaignUpdateList.length && (
                        <button
                            className="campaign-update-more"
                            onClick={seeMore}
                        >
                            See more
                        </button>
                    )}
                </>
                :
                <div className="campaignNotFound campaignUpdate">
                    <img src={isAdvisorUser ? "/assets/img/updatesAdvisorRound.svg" : "/assets/img/updatesCompanyRound.svg"} alt="" />
                    <h6 className="m-0">No updates yet</h6>
                    <p className="m-0">{isAdvisorUser ? "Stay in the loop as partners share progress and milestones. Updates will appear here once activity begins." : "Stay in the loop as companies share progress and milestones. Updates will appear here once activity begins."}</p>
                </div>

            }

        </div>
    );
};

export default CampaignUpdates;
